import { User } from '@/types';
import { can, isSuperAdmin, isSystemAdmin } from '@/core/utils';
import { Permission } from '@/core/const';
import { useFeature } from '@/core/hooks/useFeature';

export const useNavigationPermissions = (
  user: User,
): {
  canManageUsersRolesTeams: boolean;
  canManageAllOrTeamRenewals: boolean;
  canTeamManageTeams: boolean;
  canManageAllOrTeamInvoices: boolean;
  showAdminLabel: boolean;
  showStrategyLibrary: boolean;
} => {
  const canManageUsersRolesTeams =
    can(user, Permission.MANAGE_USERS) ||
    can(user, Permission.MANAGE_ROLES) ||
    can(user, Permission.MANAGE_TEAMS) ||
    isSuperAdmin(user.roles);

  const canManageAllOrTeamRenewals =
    can(user, Permission.MANAGE_RENEWALS) ||
    can(user, Permission.TEAM_MANAGE_RENEWALS);

  const canTeamManageTeams = can(user, Permission.TEAM_MANAGE_TEAMS);

  const canManageAllOrTeamInvoices =
    can(user, Permission.MANAGE_INVOICES) ||
    can(user, Permission.TEAM_MANAGE_INVOICES);

  const showAdminLabel = isSystemAdmin(user.roleType);

  const strategyLibraryEnabled = useFeature('ask_strategy_library');
  const showStrategyLibrary = canTeamManageTeams && strategyLibraryEnabled;

  return {
    canManageUsersRolesTeams,
    canManageAllOrTeamRenewals,
    canTeamManageTeams,
    canManageAllOrTeamInvoices,
    showAdminLabel,
    showStrategyLibrary,
  };
};
